<template>
  <v-app>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <AcceptInvite :invite_token="invite_token" :tos_text="tos_text" require_tos_scroll />
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import AcceptInvite from "../../shared/components/AcceptInvite";
import tos_text from "../tos.txt.yml";

export default {
  components: {
    AcceptInvite
  },
  data() {
    let invite_token;
    if (this.$route.params.token) {
      invite_token = this.$route.params.token;
    } else {
      invite_token = "";
    }
    return {
      invite_token: invite_token,
      tos_text: tos_text,
    };
  }
};
</script>

<style>
</style>